var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          actions: _vm.pageHeaderActionsConfig,
          page: _vm.pageHeaderConfig,
          "right-side-class":
            "col-sm-12 col-md-4 align-items-end d-flex pb-2 justify-content-end"
        }
      }),
      _c("board", { attrs: { details: _vm.invoiceDetailsBoard } }),
      _c(
        "div",
        { staticClass: "mt-4" },
        [
          _c("section-title", {
            attrs: { "has-line": "", title: "Historial de Plan Enmendado" }
          }),
          _vm._l(_vm.history, function(item, index) {
            return _c(
              "div",
              {
                key: `history-item-${index}`,
                staticClass: "row bg-secondary-3 rounded ml-2 mr-0 p-3 mb-2"
              },
              [
                _c(
                  "div",
                  { staticClass: "col border-right d-flex align-items-center" },
                  [
                    _c(
                      "div",
                      { staticClass: "color-black font-16 font-weight-bold" },
                      [_vm._v(" " + _vm._s(item.statusName) + " ")]
                    )
                  ]
                ),
                _c("div", { staticClass: "col" }, [
                  _c(
                    "div",
                    { staticClass: "color-gray-6 font-14 font-weight-normal" },
                    [_vm._v("Fecha:")]
                  ),
                  _c("div", { staticClass: "color-black font-weight-normal" }, [
                    _vm._v(" " + _vm._s(_vm._f("date")(item.date)) + " ")
                  ])
                ]),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-12 col-md-8 mt-3 mt-md-0 d-flex justify-content-end align-items-center"
                  },
                  [
                    _c("action-button", {
                      staticClass: "outline-success px-2",
                      attrs: {
                        i: "fas fa-file-search",
                        text: "Ver Plan",
                        variant: "outline-success"
                      },
                      on: {
                        click: function($event) {
                          return _vm.showPlan(
                            item.id,
                            item.academicYearId,
                            index
                          )
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            )
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }